// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__37-oE","logo":"Navbar_logo__2AWYt"};